import { render } from "./EditarSaldomodal.vue?vue&type=template&id=fe5c3190"
import script from "./EditarSaldomodal.vue?vue&type=script&lang=js"
export * from "./EditarSaldomodal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\frontend.avicola\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__